import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInMonths,
  differenceInSeconds,
  differenceInYears,
  format,
  parse,
} from "date-fns";

/**
 * Convert no. of seconds to time in format HH:MM:SS
 * @param seconds - no. of seconds
 */
export const secondsToTime = (
  seconds: number,
  options?: { hideHours?: boolean; format?: "h_min" },
) => {
  const h = Math.floor(seconds / 3600)
    .toString()
    .padStart(2, "0");
  const m = options?.hideHours
    ? Math.floor(seconds / 60)
        .toString()
        .padStart(2, "0")
    : Math.floor((seconds % 3600) / 60)
        .toString()
        .padStart(2, "0");
  const s = Math.floor(seconds % 60)
    .toString()
    .padStart(2, "0");

  if (options?.format === "h_min") {
    if (h === "00") {
      return `${m} min`;
    }
    return `${h} h ${m} min`;
  } else if (options?.hideHours || h === "00") {
    return `${m}:${s}`;
  }

  return `${h}:${m}:${s}`;
};

// Input date is YYYY-MM-DD HH:MM:SS and in UTC time
export const getDateFromUTCString = (dateString: string) => {
  try {
    return new Date(
      dateString.toUpperCase().endsWith("Z") ? dateString : dateString + "Z",
    );
  } catch (e) {
    return undefined;
  }
};

// Input date is YYYY-MM-DD HH:MM:SS and in Local time
export const getDateFromLocalString = (dateString: string) => {
  try {
    return parse(dateString, "yyyy-MM-dd HH:mm:ss", new Date());
  } catch (e) {
    return undefined;
  }
};

export const formatRelativeDateForCommunity = (date: Date) => {
  const now = new Date();
  const secondsDiff = differenceInSeconds(now, date);

  if (secondsDiff <= 1) {
    return "1s";
  }

  if (secondsDiff < 60) {
    return `${secondsDiff}s`;
  }

  const minutesDiff = differenceInMinutes(now, date);
  if (minutesDiff < 60) {
    return `${minutesDiff}m`;
  }

  const hoursDiff = differenceInHours(now, date);
  if (hoursDiff < 24) {
    return `${hoursDiff}h`;
  }

  const daysDiff = differenceInDays(now, date);
  if (daysDiff < 30) {
    return `${daysDiff}d`;
  }

  const monthsDiff = differenceInMonths(now, date);
  if (monthsDiff < 12) {
    return `${monthsDiff}mon`;
  }

  const yearsDiff = differenceInYears(now, date);
  return `${yearsDiff}y`;
};

// For API usage not display
export const getCurrentDateTime = () => {
  return format(new Date(), "yyyy-MM-dd HH:mm:ss");
};
export const getDateStringFromDateTime = (date: Date) => {
  return format(date, "yyyy-MM-dd HH:mm:ss");
};

export const getDateFromTimestamp = (timestamp: number) => {
  return new Date(timestamp * 1000);
};
